module.exports = __webpack_public_path__ + "img/coins-balance-paytype.c2f00342.png";